<template>
  <header class="header" v-bind:class='{ "is-fixed" : fixed, "has-shadow" : fixed }'>
    <div class="header__logo">
      <a class="header__logo--anchor" href="/">
        <img class="header__logo--image" src="static/img/logo.svg" v-bind:alt="$lang.altimg.logo" width="150" height="65">
      </a>
    </div>
    <div class="header__box">
      <div class="header__box--search header__search" v-if="fixed">
        <search-form></search-form>
      </div>
      <div class="header__box--font header__font" v-on:click="toggleFont" v-bind:class="{ 'is-active': isActiveFont, 'is-bigger-font': isFontSet }">
        <a href="" class="header__font--select" v-bind:title="$lang.header.font" v-on:click.prevent="">
          <span class="onp-font"></span>
        </a>
        <div class="header__font--dropdown header__dropdown">
          <a href="" class="header__dropdown--item" v-bind:class="{ 'is-active': fontSize == value }" v-on:click.prevent="setFont(value)" v-for="(key, value) in $lang.fonts.name">
            <span class="header__font--symbol">
              A
              <sup v-if="value == 'medium'">+</sup>
              <sup v-if="value == 'big'">++</sup>
            </span>
            {{ key }}
          </a>
        </div>
      </div>
      <div class="header__box--lang header__lang" v-on:click="toggleLang" v-bind:class="{ 'is-active': isActiveLang }">
        <a href="" class="header__lang--select" v-on:click.prevent="">
          {{ $lang.language.toUpperCase() }}
        </a>
        <div class="header__lang--dropdown header__dropdown">
          <a href="" class="header__dropdown--item" v-bind:class="{ 'is-active': isActiveLangClass(lang)}"  v-for="lang in $langs" v-on:click.prevent="setLang(lang)">{{$lang.langs[lang]}}</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import SearchForm from './../Search/SearchForm'
import { mapGetters } from 'vuex'

export default {
  name: 'header',
  components: {
    'search-form': SearchForm
  },
  data () {
    return {
      isActiveLang: false,
      isActiveFont: false,
      isFontSet: false
    }
  },
  methods: {
    // font switcher
    toggleFont () {
      this.isActiveFont = !this.isActiveFont;
    },
    setFont (val) {
        this.$cookies.set('font', val)
        this.$store.commit('SET_FONT_SIZE', val)
        this.checkIfFontSet(val)
    },
    checkIfFontSet (val) {
      if (val == "medium" || val == "big") {
        this.isFontSet = true
      } else {
        this.isFontSet = false
      }
    },
    // toggle lang switcher
    toggleLang () {
      this.isActiveLang = !this.isActiveLang;
    },
    // check if language is the one currently set in vue-langugae
    isActiveLangClass (lang) {
      return lang == this.$lang.language
    },
    setLang (lang) {
      // set lang in vue-language
      this.$setLang(lang);
      // remove current language in cookies
      this.$cookies.remove('lang');
      // set new language in cookies
      this.$cookies.set('lang', lang);
    }
  },
  created () {
    let font = this.$cookies.get('font')
    if (font) {
      this.$store.commit('SET_FONT_SIZE', font)
    }
    this.checkIfFontSet(font)
  },
  computed: {
    ...mapGetters({
      fontSize: 'GET_FONT_SIZE',
      fixed: 'GET_APP_SCROLL'
    })
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?8f170912